module.exports = __webpack_public_path__ + "img/secretum-secretorum-2.70cc9b4d.webp";